import { Box, Button, styled } from '@mui/material';

import { COLORS } from '../../../../../configs/colors';

export const ActionBarContainer = styled(Box)({
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  background: 'rgba(255, 255, 255, 0.8)',
  backdropFilter: 'blur(20px)',
  WebkitBackdropFilter: 'blur(20px)',
  borderTop: '1px solid rgba(0, 0, 0, 0.06)',
  boxShadow: '0 -4px 20px rgba(0, 0, 0, 0.06)',
  paddingBottom: 'env(safe-area-inset-bottom)',
  zIndex: 20,
});

export const ButtonGrid = styled(Box)({
  display: 'grid',
  gridTemplateColumns: 'repeat(4, 1fr)',
  gap: '8px',
  padding: '10px 16px',
});

interface ActionButtonProps {
  buttonVariant?: 'primary' | 'secondary';
}

export const ActionButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'buttonVariant',
})<ActionButtonProps>(({ buttonVariant = 'secondary' }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '2px',
  padding: '8px 6px',
  minHeight: '48px',
  minWidth: '48px',
  borderRadius: '16px',
  textTransform: 'none',
  fontSize: '0.6rem',
  fontWeight: 600,
  letterSpacing: '0.3px',
  lineHeight: 1.2,
  transition: 'background-color 0.2s, transform 0.1s',
  '& .MuiSvgIcon-root': {
    fontSize: '1.25rem',
  },
  '&:active': {
    transform: 'scale(0.95)',
  },
  ...(buttonVariant === 'primary'
    ? {
        background: `linear-gradient(135deg, ${COLORS.NavyBlue} 0%, ${COLORS.NavyBlueDark} 100%)`,
        color: COLORS.White,
        boxShadow: '0 4px 12px rgba(23, 104, 120, 0.3)',
        '&:hover': {
          background: `linear-gradient(135deg, ${COLORS.NavyBlueDark} 0%, ${COLORS.NavyBlueDark} 100%)`,
        },
      }
    : {
        backgroundColor: COLORS.SlateLight,
        color: COLORS.SlateDark,
        '&:hover': {
          backgroundColor: COLORS.SlateMedium,
        },
      }),
}));

export const HiddenInput = styled('input')({
  display: 'none',
});
